import { GtmStatsTracker } from './tracker';
import { GtmWindowInterface } from '../window.interface';
import { StatsDebuggerService } from '../../../service/stats-debugger/service';
import { StatsGuardService } from '../../../service/stats-guard/service';
import { WindowService } from '../../../service/window/service';
import { DataQueueDelayedFactory } from '../../data/queue/delayed.factory';

export function GtmStatsTrackerFactory(): GtmStatsTracker {
  // Setup data queue
  const dataQueue = DataQueueDelayedFactory();
  dataQueue.setDelay(1000);

  return new GtmStatsTracker(
    <GtmWindowInterface>WindowService().getNative(),
    dataQueue,
    StatsDebuggerService(),
    StatsGuardService()
  );
}
